export default class Asset {
  constructor(file) {
    this.file               = file
    this.filename           = file.filename
    this.filetype           = file.filetype
    this.width              = file.width
    this.height             = file.height
    this.size               = file.size
    this.url                = file.url
    this.friendlyFilename   = this.friendlyFilename.bind(this)
    this.friendlyFileSize   = this.friendlyFileSize.bind(this)
    this.friendlyDimensions = this.friendlyDimensions.bind(this)
    this.portrait           = this.portrait.bind(this)
    this.landscape          = this.landscape.bind(this)
    this.aspectRatio        = this.aspectRatio.bind(this)
    this.scaleWidthTo       = this.scaleWidthTo.bind(this)
    this.scaleHeightTo      = this.scaleHeightTo.bind(this)
    this.minimumWidth       = this.minimumWidth.bind(this)
    this.minimumHeight      = this.minimumHeight.bind(this)
  }

  static friendlyFilename(filename) {
    return filename.replace(/\.[^/.]+$/, "").replace(/_/g, " ")
  }

  static friendlyFileSize(size) {
    if (size < 1024) {
      size = Math.round(size / 1024 * 100) / 100
      return `${size} bytes`
    } else if ( size < 1024 * 1024) {
      size = Math.round(size / 1024 * 100) / 100
      return `${size} KB`
    } else if (size < 1024 * 1024 * 1024) {
      size = Math.round(size / 1024 / 1024 * 100) / 100
      return `${size} MB`
    } else {
      size = Math.round(size / 1024 / 1024 / 1024 * 100) / 100
      return `${size} GB`
    }
  }

  static friendlyDimensions(width, height) {
    return `${width} × ${height}`
  }

  static aspectRatio(width, height) {
    return (width / height) || 1
  }

  friendlyFilename() {
    return Asset.friendlyFilename(this.filename)
  }

  friendlyFileSize() {
    return Asset.friendlyFileSize(this.size)
  }

  friendlyDimensions() {
    return Asset.friendlyDimensions(this.width, this.height)
  }

  aspectRatio() {
    return Asset.aspectRatio(this.width, this.height)
  }

  portrait() {
    return this.height > this.width
  }

  landscape() {
    return this.width > this.height
  }

  scaleWidthTo(height) {
    return Math.round(height * this.aspectRatio())
  }

  scaleHeightTo(width) {
    return Math.round(width / this.aspectRatio())
  }

  minimumHeight(height=1) {
    if (this.portrait()) {
      if (height * this.aspectRatio() < 1) {
        return this.minimumHeight(height+=1)
      } else {
        return height
      }
    } else {
      if (this.aspectRatio() / height < 1) {
        return this.minimumHeight(height+=1)
      } else {
        return height
      }
    }
  }

  minimumWidth(width=1) {
    if (this.portrait()) {
      if (width / this.aspectRatio() < 1) {
        return this.minimumWidth(width+=1)
      } else {
        return width
      }
    } else {
      if (width / this.aspectRatio() < 1) {
        return this.minimumWidth(width+=1)
      } else {
        return width
      }
    }
  }
}
